module.exports = __webpack_public_path__ + "img/2f_l_twodays.526b359d.jpg";